import { IntlProvider } from '~i18n';
import { ApolloProvider } from '~api';
import { SilentErrorBoundary } from '~features/error';
import { HostPropsContext, type HostPropsContextValue } from '~features/host-props';
import { ThemeProvider } from '~ui/theme-provider';
import { TrackingProvider } from '~features/tracking';
import { ViewWrapper } from '~ui/components';
import { DataProvider } from './data-provider';
import { JobAdSection as BaseJobAdSection } from './job-ad-section';

export type Props = HostPropsContextValue &
  Omit<React.ComponentPropsWithoutRef<typeof BaseJobAdSection>, 'profile'> & {
    uuid: string;
  };

const JobAdSection = (props: Props) => {
  if (!props.user) {
    return null;
  }

  return (
    <SilentErrorBoundary>
      <HostPropsContext.Provider value={props}>
        <ThemeProvider platform={props.platform}>
          <ViewWrapper data-testid="company-profile-job-ad-root">
            <IntlProvider>
              <ApolloProvider>
                <DataProvider uuid={props.uuid}>
                  {({ profile, loading }) =>
                    !loading && (
                      <TrackingProvider
                        employerUserId={profile?.userId}
                        loading={loading}
                        forceTouchPointPage="ad_page"
                      >
                        <BaseJobAdSection profile={profile} {...props} />
                      </TrackingProvider>
                    )
                  }
                </DataProvider>
              </ApolloProvider>
            </IntlProvider>
          </ViewWrapper>
        </ThemeProvider>
      </HostPropsContext.Provider>
    </SilentErrorBoundary>
  );
};

export default JobAdSection;
